import { useColorPickerClipboard } from "client/hooks/utils/useColorpickerClipboard";
import { useEffect, useState } from "react";
import { ColorInfoCardProps } from "./ColorInfoCard";

export const useColorInfoCard = ({ source, color, colorFormat }: ColorInfoCardProps) => {
    const { handleCopy, isCopied } = useColorPickerClipboard(source);
    const [showInput, setShowInput] = useState(false);
    const [colorError, setColorError] = useState("");
    function onCopyClick() {
        handleCopy(color[colorFormat]);
    }
    function onTextClick() {
        // onCopyClick();
        setShowInput(true);
    }
    function handleColorFormatChange() {
        setColorError(``);
    }
    useEffect(handleColorFormatChange, [colorFormat]);
    return {
        isCopied,
        onCopyClick,
        showInput,
        setShowInput,
        onTextClick,
        colorError,
        setColorError,
    };
};
